import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acadmics',
  templateUrl: './acadmics.component.html',
  styleUrls: ['./acadmics.component.css']
})
export class AcadmicsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
